// Who shares the credit for a job (jobs.setSplits): each tech's share in percent, evenly by default,
// set by the office at review; the shares lock when the job is completed. On the job page's review.
import { useState } from 'react';
import { splitsProblem } from '../review/review-model.ts';

export function Splits({
  initial,
  source,
  name,
  busy,
  onSave,
}: {
  initial: { staffId: string; pct: string }[];
  source: 'auto' | 'manual';
  name: (id: string) => string;
  busy: boolean;
  onSave: (splits: { staffId: string; pct: string }[]) => Promise<boolean>;
}) {
  const [rows, setRows] = useState(initial.map((s) => ({ ...s, pct: String(Number(s.pct)) })));
  const problem = splitsProblem(rows);
  const changed = rows.some((r, i) => Number(r.pct) !== Number(initial[i]?.pct));
  if (rows.length < 2) return null; // one tech has it all: nothing to share or set (QA-333)
  return (
    <div className="block">
      <h4>Who shares the credit</h4>
      <p className="muted small">
        {source === 'auto' ? 'Shared evenly between the techs on the job.' : 'Set by the office.'} Each tech’s
        pay for the job follows their share; the shares lock when the job is completed.
      </p>
      <ul className="rows">
        {rows.map((r, i) => (
          <li key={r.staffId} className="mat">
            <label htmlFor={`split-${r.staffId}`}>{name(r.staffId)}</label>
            <span className="row">
              <input
                id={`split-${r.staffId}`}
                className="field pct"
                inputMode="decimal"
                value={r.pct}
                onChange={(e) => setRows(rows.map((x, j) => (j === i ? { ...x, pct: e.target.value } : x)))}
              />
              %
            </span>
          </li>
        ))}
      </ul>
      {changed && problem && <p className="error small">{problem}</p>}
      {changed && (
        <button className="btn" disabled={busy || !!problem} onClick={() => void onSave(rows)}>
          Save shares
        </button>
      )}
    </div>
  );
}
